import React, { ReactNode } from "react";

import { AnimateTranslate, HeadingText } from "styles";

type Props = {
  children: ReactNode;
};

export const PageHeaderSubtitle = (props: Props) => {
  return (
    <AnimateTranslate>
      <HeadingText $variant="heading02" className="pb-6" as="h2">
        {props.children}
      </HeadingText>
    </AnimateTranslate>
  );
};
